import { render, staticRenderFns } from "./AppLuggageCard.vue?vue&type=template&id=ec5674f2&scoped=true&"
import script from "./AppLuggageCard.vue?vue&type=script&lang=js&"
export * from "./AppLuggageCard.vue?vue&type=script&lang=js&"
import style0 from "./AppLuggageCard.vue?vue&type=style&index=0&id=ec5674f2&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5674f2",
  null
  
)

export default component.exports